<template>
  <b-navbar
    toggleable="md"
    :class="{ 'navbar-dark bg-dark': !isDarkMode, 'navbar-dark bg-dark border-bottom': isDarkMode }"
    fixed="top"
  >
    <b-navbar-brand :to="navbarBrandRoute">
      <img class="box-shadow2" src="../assets/images/Spencers_Logo.png" width="60" />
<img class="box-shadow2 ml-2 mb-1" src="../assets/images/natureBasket.jpeg" width="60" />
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <template v-if="isQmsOtpGuestSession">
          <b-nav-item :to="{ path: '/qms' }" data-cy="nav-bar-qms-otp-guest">
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" /> QMS
          </b-nav-item>
          <b-nav-item :to="{ path: '/qms/new' }" data-cy="nav-bar-qms-new-guest">
            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" /> New query
          </b-nav-item>
        </template>
        <template v-else>
          <b-nav-item v-if="qmsNavBarItemPermission" :to="{ path: '/qms' }" data-cy="nav-bar-qms-admin">
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" /> QMS
          </b-nav-item>
          <b-nav-item v-if="qmsNavBarItemPermission" :to="{ path: '/qms/admin' }">
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" /> QMS Admin
          </b-nav-item>
          <b-nav-item v-if="qmsNavBarItemPermission" :to="{ path: '/qms/closure-remarks' }">
            <font-awesome-icon :icon="['fas', 'list-alt']" class="mr-1" /> Closure Remarks
          </b-nav-item>
          <b-nav-item
            v-if="qmsEscalationMatrixNavBarItemPermission"
            :to="{ path: '/qms/escalation-matrix' }"
            data-cy="nav-bar-qms-escalation-matrix"
          >
            <font-awesome-icon :icon="['fas', 'sitemap']" class="mr-1" /> Escalation Matrix
          </b-nav-item>
          <b-nav-item
            v-if="dropdownsAdminNavBarItemPermission"
            :to="{ path: '/dropdowns-admin' }"
            data-cy="nav-bar-dropdowns-admin"
          >
            <font-awesome-icon :icon="['fas', 'list']" class="mr-1" /> Dropdowns Admin
          </b-nav-item>
          <b-nav-item :to="{ path: '/' }" v-if="dashboardNavBarItemPermission" data-cy="nav-bar-dashboard">
            <font-awesome-icon :icon="['fas', 'border-all']" class="mr-1" />Dashboard
          </b-nav-item>
          <b-nav-item
            :to="{ path: '/report' }"
            v-if="reportNavBarItemPermission || specialReportNavBarItemPermission"
            data-cy="nav-bar-dashboard"
          >
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" />Reports
          </b-nav-item>
          <!-- <b-nav-item-dropdown :variant="isDarkMode ? 'primary' : 'success'" -->
          <!--       :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'" v-if="specialReportNavBarItemPermission" right data-cy="nav-bar-manage-setting"> -->
          <!--   <template v-slot:button-content> -->
          <!--     <font-awesome-icon :icon="['fas', 'chart-line']" class="mr-1" />Reports -->
          <!-- </template> -->
          <!-- <b-dropdown-item                   :link-class="isDarkMode ? 'text-light bg-dark' : ''" :to="{ path: '/report' }" v-if="reportPermission" data-cy="nav-bar-staff"> -->
          <!--   <font-awesome-icon :icon="['fas', 'chart-bar']" class="mr-1" />Report -->
          <!-- </b-dropdown-item> -->
          <!-- <b-dropdown-item -->
          <!--  :link-class="isDarkMode ? 'text-light bg-dark' : ''" -->
          <!--   v-if="foodSafetyPermission" -->
          <!--   :to="{ path: '/foodSafety_Reports' }" -->
          <!--   data-cy="nav-bar-general-settings" -->
          <!-- > -->
          <!--   <font-awesome-icon :icon="['fas', 'seedling']" class="mr-1" /> Food Safety Reports -->
          <!-- </b-dropdown-item> -->
          <!-- </b-nav-item-dropdown> -->

          <b-nav-item-dropdown
            :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
            v-if="checklistNavBarItemPermission"
            right
            data-cy="nav-bar-manage-setting"
          >
            <template v-slot:button-content>
              <font-awesome-icon :icon="['fas', 'check']" class="mr-1" />Checklist
            </template>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/checklist' }"
              data-cy="nav-bar-staff"
              v-if="viewChecklistPermission"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="mr-1" /> View Checklist
            </b-dropdown-item>
            <!-- <b-dropdown-item -->
            <!-- :link-class="isDarkMode ? 'text-light bg-dark' : ''" -->
            <!--   :to="{ path: '/checklistV2' }" -->
            <!--   data-cy="nav-bar-staff" -->
            <!--   v-if="viewFoodSafetyChecklistPermission" -->
            <!-- > -->
            <!--   <font-awesome-icon :icon="['fas', 'leaf']" class="mr-1" />Food Safety Checklist -->
            <!-- </b-dropdown-item> -->
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/checklist-fill' }"
              v-if="fillChecklistPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" /> Fill Checklist
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{ path: '/form' }" v-if="dynamicFormNavBarPermission" data-cy="nav-bar-staff">
            <font-awesome-icon :icon="['fas', 'boxes']" class="mr-1" />Dynamic Forms
          </b-nav-item>

          <b-nav-item v-if="eventNavBarItemPermission" :to="{ path: '/photo-sharing-event' }" data-cy="nav-bar-staff">
            <font-awesome-icon :icon="['fas', 'gifts']" class="mr-1" />Events
          </b-nav-item>

          <b-nav-item-dropdown
            :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
            v-if="npsNavBarItemPermission"
            right
            data-cy="nav-bar-manage-setting"
          >
            <template v-slot:button-content>
              <font-awesome-icon :icon="['fas', 'receipt']" class="mr-1" />NPS
            </template>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/vendorFeedbackReport' }"
              data-cy="nav-bar-general-settings"
              v-if="npsVenderPermission"
            >
              <font-awesome-icon :icon="['fas', 'shopping-bag']" class="mr-1" /> NPS Vendor
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/nps' }"
              data-cy="nav-bar-general-settings"
              v-if="npsCustomerPermission"
            >
              <font-awesome-icon :icon="['fas', 'user']" class="mr-1" /> Voice Of Customer
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
            v-if="moreFunctionNavBarItemPermission"
            right
            data-cy="nav-bar-manage-setting"
          >
            <template v-slot:button-content>
              <font-awesome-icon :icon="['fas', 'sitemap']" class="mr-1" />More Functions
            </template>

            <b-dropdown-item
              v-if="qmsPermission"
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/qms' }"
              data-cy="nav-bar-qms"
            >
              <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" /> QMS
            </b-dropdown-item>
            <b-dropdown-item
              v-if="qmsEscalationMatrixNavBarItemPermission"
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/qms/escalation-matrix' }"
              data-cy="nav-bar-qms-escalation-matrix-more"
            >
              <font-awesome-icon :icon="['fas', 'sitemap']" class="mr-1" /> Escalation Matrix
            </b-dropdown-item>
            <b-dropdown-item
              v-if="dropdownsAdminNavBarItemPermission"
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/dropdowns-admin' }"
              data-cy="nav-bar-dropdowns-admin-more"
            >
              <font-awesome-icon :icon="['fas', 'list']" class="mr-1" /> Dropdowns Admin
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/complain' }"
              v-if="supportTicketsPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" /> Tickets
            </b-dropdown-item>

            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/pop' }"
              v-if="popPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'print']" class="mr-1" />POP
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/cx-pulse-360' }"
              v-if="tms"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" />CX Pulse 360
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="kycPermission"
              :to="{ path: '/kyc' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'handshake']" class="mr-1" /> Sampark
            </b-dropdown-item>

            <!-- <b-dropdown-item
            :link-class="isDarkMode ? 'text-light bg-dark' : ''"
            v-if="ticketsPermission"
            :to="{ path: '/complain' }"
            data-cy="nav-bar-general-settings"
          >
            <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" /> Tickets
          </b-dropdown-item> -->

            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="transactionComplainPermission"
              :to="{ path: '/transaction-complain' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" /> Transaction Complain
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="eneTracker"
              :to="{ path: '/eneTracker' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" /> EnE Tracker
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="rtv"
              :to="{ path: '/rtv' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ticket-alt']" class="mr-1" /> RTV
            </b-dropdown-item>

            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="osaReportPermission"
              :to="{ path: '/barcodeScan' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'barcode']" class="mr-1" /> OSA Report
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="kycInstitutionalPermission"
              :to="{ path: '/kycInstitutional' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'fingerprint']" class="mr-1" /> KYC Institutional
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="storeLicensedPermission"
              :to="{ path: '/license-upload' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'id-card']" class="mr-1" />Store Licenses
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="promoCodePermission"
              :to="{ path: '/promo-code' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'ad']" class="mr-1" /> Promo Code
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/gift-distribute-app' }"
              data-cy="nav-bar-general-settings"
              v-if="giftIssuancePermission"
            >
              <font-awesome-icon :icon="['fas', 'hand-holding-usd']" class="mr-1" /> Gift Issuance
            </b-dropdown-item>

            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="commentsPermission"
              :to="{ path: '/comments' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'comments']" class="mr-1" /> Comments
            </b-dropdown-item>

            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="notesPermission"
              :to="{ path: '/notes' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'pen']" class="mr-1" /> Notes
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/schedule' }"
              v-if="schedulesPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'calendar-check']" class="mr-1" /> Schedules
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/tags' }"
              v-if="tagsPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'tags']" class="mr-1" /> Tags
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="storeDocumentPermission"
              :to="{ path: '/document-share' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-1" />Store Documents
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/video' }"
              v-if="videosPermission"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'play']" class="mr-1" /> Videos
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
            v-if="staffNavBarItemPermission"
            right
            data-cy="nav-bar-manage-setting"
          >
            <template v-slot:button-content>
              <font-awesome-icon :icon="['fas', 'users']" class="mr-1" />Staff
            </template>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/user' }"
              data-cy="nav-bar-general-settings"
              v-if="userPermission"
            >
              <font-awesome-icon :icon="['fas', 'user-tie']" class="mr-1" /> Users
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              :to="{ path: '/role' }"
              data-cy="nav-bar-general-settings"
              v-if="rolesPermission"
            >
              <font-awesome-icon :icon="['fas', 'at']" class="mr-1" /> Roles
            </b-dropdown-item>
            <b-dropdown-item
              :link-class="isDarkMode ? 'text-light bg-dark' : ''"
              v-if="storesPermission"
              :to="{ path: '/stores' }"
              data-cy="nav-bar-general-settings"
            >
              <font-awesome-icon :icon="['fas', 'store']" class="mr-1" /> Stores
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{ path: '/petty-cash' }" v-if="pettyCashNavBarItemPermission" data-cy="nav-bar-staff">
            <font-awesome-icon :icon="['fas', 'rupee-sign']" class="mr-1" />Petty Cash<span class="custom_plus"></span>
          </b-nav-item>
        </template>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{ path: '/chat' }" v-if="chatPermission" data-cy="nav-bar-chat">
          <font-awesome-icon :icon="['fas', 'comments']" class="mr-1" />Chat
        </b-nav-item>
        <b-nav-item id="tooltip-button-disable" v-if="isDarkMode" @click="handleDarkMode()">
          <font-awesome-icon :icon="['fas', 'sun']" class="mr-1" />
        </b-nav-item>
        <b-nav-item id="tooltip-button-disable" v-if="!isDarkMode" @click="handleDarkMode()">
          <font-awesome-icon :icon="['fas', 'moon']" class="mr-1" />
        </b-nav-item>
        <b-tooltip :hidden="handleTooltip" variant="info" target="tooltip-button-disable">
          Use Disha With Eyes Comfort
        </b-tooltip>
        <b-nav-item
          v-if="!isQmsOtpGuestSession && !isQmsPayrollClosureRole"
          class="contactButton"
          :to="{ path: '/contactUs' }"
        >
          <font-awesome-icon :icon="['fas', 'envelope']" class="mr-1" /> Help
        </b-nav-item>
        <b-nav-item-dropdown
          :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
          right
          data-cy="nav-bar-manage-setting"
        >
          <template v-slot:button-content>
            <font-awesome-icon :icon="['fas', 'user']" class="mr-1" />{{ navUserFirstName }}
          </template>
          <b-dropdown-item
            v-if="!isQmsOtpGuestSession"
            :link-class="isDarkMode ? 'text-light bg-dark' : ''"
            target="_blank"
            link-classes="btn btn-grey mx-1"
            href="https://yvm.spencersretail.com "
            data-cy="nav-bar-general-settings"
          >
            <font-awesome-icon :icon="['fas', 'check']" class="mr-1" />Go To YVM
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!isQmsOtpGuestSession"
            :link-class="isDarkMode ? 'text-light bg-dark' : ''"
            target="_blank"
            link-classes="btn btn-grey mx-1"
            href="https://spencer-doc-share.s3.ap-south-1.amazonaws.com/CRM+V1+ENG+EDITED.pdf"
            data-cy="nav-bar-general-settings"
          >
            <font-awesome-icon :icon="['fas', 'question-circle']" class="mr-1" />User Manual
          </b-dropdown-item>
          <b-dropdown-item
            :link-class="isDarkMode ? 'text-light bg-dark' : ''"
            :to="{ path: '/logout' }"
            link-classes="btn btn-grey mx-1"
            data-cy="nav-bar-logout"
          >
            <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="mr-1" /> Logout
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- <b-nav-item v-if="user" data-cy="nav-bar-welcome-text" @click="onClick">Help</b-nav-item> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { Permissions } from '../helper/navBarHelper';

export default {
  name: 'NavBar',
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('cstSubmission', ['store']),
    ...mapGetters('auth', [
      'isFoodSafetyTeam',
      'isFoodSafetyAdmin',
      'isLoggedIn',
      'isQmsPayrollClosureRole',
      'isQMSAdmin'
    ]),
    navbarBrandRoute() {
      if (this.isQmsOtpGuestSession || this.isQMSAdmin) {
        return { path: '/qms' };
      }
      return { path: '/' };
    },
    isQmsOtpGuestSession() {
      if (typeof sessionStorage === 'undefined') {
        return false;
      }
      return sessionStorage.getItem('qmsOtpVerified') === 'true' && !this.isLoggedIn();
    },
    navUserFirstName() {
      if (this.user && this.user.name) {
        return this.user.name.split(' ')[0];
      }
      if (this.isQmsOtpGuestSession) {
        return localStorage.getItem('qms-mobile-number') || 'QMS';
      }
      return '';
    }
  },
  mounted() {
    if (this.isQmsOtpGuestSession) {
      return;
    }
    this.getStoreByUser();
    this.handlePermissions();
  },
  data() {
    return {
      handleTooltip: false,
      darkMode: 'light',
      specialReportNavBarItemPermission: false,
      dashboardNavBarItemPermission: false,
      reportNavBarItemPermission: false,
      checklistNavBarItemPermission: false,
      dynamicFormNavBarPermission: false,
      eventNavBarItemPermission: false,
      npsNavBarItemPermission: false,
      moreFunctionNavBarItemPermission: false,
      staffNavBarItemPermission: false,
      pettyCashNavBarItemPermission: false,
      reportPermission: false,
      foodSafetyPermission: false,
      viewChecklistPermission: false,
      viewFoodSafetyChecklistPermission: false,
      fillChecklistPermission: false,
      npsVenderPermission: false,
      npsCustomerPermission: false,
      supportTicketsPermission: false,
      popPermission: false,
      tms: false,
      ticketsPermission: false,
      transactionComplainPermission: false,
      eneTracker: false,
      rtv: false,
      osaReportPermission: false,
      kycPermission: false,
      kycInstitutionalPermission: false,
      storeLicensedPermission: false,
      promoCodePermission: false,
      giftIssuancePermission: false,
      qmsPermission: false,
      qmsNavBarItemPermission: false,
      qmsEscalationMatrixNavBarItemPermission: false,
      dropdownsAdminNavBarItemPermission: false,
      commentsPermission: false,
      notesPermission: false,
      schedulesPermission: false,
      tagsPermission: false,
      storeDocumentPermission: false,
      videosPermission: false,
      userPermission: false,
      rolesPermission: false,
      storesPermission: false,
      assignedStore: '',
      chatPermission: false
    };
  },
  watch: {
    store(newValue) {
      if (newValue.length > 0) {
        this.assignedStore = newValue.map(item => item.storeid);
      }
    }
  },
  methods: {
    ...mapActions('cstSubmission', ['getStoreByUser']),
    handleDarkMode() {
      this.handleTooltip = true;
      this.$emit('handleDark', {});
    },
    handlePermissions() {
      const userPermissions = Permissions(this.user, this.store);
      const userHaveAiAccess = this.user?.roles?.filter(role => role._id === '69f197411b2324e71b7805d0')?.length > 0;
      if (userPermissions) {
        userPermissions.forEach(permission => {
          if (this.$data.hasOwnProperty(permission)) {
            this.$data[permission] = true;
          }
        });
      } else {
        const defaultUser = [
          'reportNavBarItemPermission',
          'checklistNavBarItemPermission',
          'fillChecklistPermission',
          'dynamicFormNavBarPermission',
          'eventNavBarItemPermission',
          'moreFunctionNavBarItemPermission',
          'supportTicketsPermission',
          'osaReportPermission',
          'kycPermission',
          'commentsPermission',
          'notesPermission'
        ];
        defaultUser.forEach(permission => {
          if (this.$data.hasOwnProperty(permission)) {
            this.$data[permission] = true;
          }
        });
      }
      if (userHaveAiAccess && this.$data.hasOwnProperty('chatPermission')) {
        this.$data.chatPermission = true;
      }
    }
  }
};
</script>
